import React     from 'react';
import PropTypes from 'prop-types';

class VXLink extends React.PureComponent {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		if (typeof this.props.onClick === "function") {
			e.preventDefault();
			e.stopPropagation();

			this.props.onClick();
		}
	}

	render() {
		let className = 'vxlink';

		if (this.props.disabled) {
			className += ' -disabled';
		}

		if (this.props.additionalClasses) {
			className += ' ';
			className += this.props.additionalClasses;
		}

		return <a className={className} href={this.props.url} onClick={this.onClick}>{this.props.text}</a>;
	}

}

VXLink.propTypes = {
	text:              PropTypes.string.isRequired,
	url:               PropTypes.string,
	onClick:           PropTypes.func,
	disabled:          PropTypes.bool,
	additionalClasses: PropTypes.string,
};

VXLink.defaultProps = {
	url:               '#',
	additionalClasses: '',
	onClick:           null,
	disabled:          false,
};

export default VXLink;